import { render, staticRenderFns } from "./QuestionPicker.vue?vue&type=template&id=1324a997&scoped=true&"
import script from "./QuestionPicker.vue?vue&type=script&lang=js&"
export * from "./QuestionPicker.vue?vue&type=script&lang=js&"
import style0 from "./QuestionPicker.vue?vue&type=style&index=0&id=1324a997&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1324a997",
  null
  
)

export default component.exports